export default {"src":"/_next/static/media/ifood-logo.4bc7ec3f.svg","height":106,"width":201,"blurWidth":0,"blurHeight":0};